import React from 'react'
import { Link } from 'react-router-dom'
import { GetNavigations } from '../Functions/functions'

const Footer = ({ privacyPolicyData, cookiePolicyData }) => {
    return (
        <div className='privacyAndCookieBottom'>
            {privacyPolicyData && (
                <Link to={GetNavigations("/privacy")} target="_blank">Privacy Policy</Link>
            )}
            {privacyPolicyData && cookiePolicyData && (
                <span className='privacyAndCookieDivider' />
            )}
            {
                cookiePolicyData && (
                    <Link to={GetNavigations("/cookie")} target="_blank">Cookie Policy</Link>
                )
            }
        </div>
    )
}

export default Footer